/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-27 16:02:16
 * @LastEditors: K
 * @LastEditTime: 2022-10-09 09:27:30
 */
import { unwrapResult } from "@reduxjs/toolkit"
import {
  Button,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  Popover,
  Radio,
  Row,
  Select,
  Space,
  Tag,
} from "antd"
import moment from "moment"
import React, { ReactElement, useContext, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { ThemeContext } from "../../../theme/ThemeContext"
import { DateTimeFormat, DateTimeFormatSimple } from "../../../models/datetime"
import styles from "../maintenance.module.css"
import RightIcon from "../assets/right.png"
import {
  getAntibacterialStateName,
  getAskTypeName,
  getChildItem,
  getInstitutionalLevelName,
  getKey,
  getOperateStatusName,
  getOperateTypeName,
  getOwnershipTypeName,
  getServiceName,
  hasValue,
} from "./data"
import {
  getAnestheticDrugName,
  getAntibacterialName,
  getAppointName,
  getDoctorKey,
  getDoctorName,
  getEducationName,
  getOperateName,
  getPracticeCategoryName,
  getPracticeLevelName,
  getSexName,
} from "../doctor/doctor"

interface ReCordModalProps {
  visible: boolean
  data?: any
  type: number
  onWithdraw?: (v: any) => void
  onChange?: (v: any) => void
  onCancel: () => void
}

export const ApplicationRecord = ({
  visible,
  data = [],
  type,
  onWithdraw,
  onChange,
  onCancel,
}: ReCordModalProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  return (
    <Modal
      visible={visible}
      title="申请记录"
      width={800}
      footer={null}
      onCancel={onCancel}
    >
      <Col 
        style={{
          maxHeight: "70vh",
          overflowY: "auto",
          paddingRight: '10px',
          paddingLeft: '10px',
        }}
      >
        {data?.map((v: any, index: number) => {
          return (
            <div className={styles.record} key={index}>
              <div className={styles.recordItem}>
                <div
                  className={styles.flex}
                  style={{
                    paddingBottom: "10px",
                    borderBottom: "1px solid #eee",
                    paddingRight: "4px",
                  }}
                >
                  <span>申请时间：{moment(v?.createTime).format(DateTimeFormat)}</span>
                  <span>申请人：{v?.applyUser}</span>
                  <span>类型：{getAskTypeName(v?.askType)}</span>
                  {v?.state == 0 ? (
                    <span style={{ color: "#FFBF1B" }}>待审核</span>
                  ) : v?.state == 1 ? (
                    <span style={{ color: "#2D7BFF" }}>已审核</span>
                  ) : v?.state == 2 ? (
                    <span style={{ color: "#FF1B1B" }}>已撤回</span>
                  ) : (
                    <span style={{ color: "#FF1B1B" }}>已拒绝</span>
                  )}
                </div>
                <div className={styles.flex} style={{ paddingTop: "16px" }}>
                  <b>{v?.physicianName ? `医生"${v?.physicianName}"` : ''}申请调整内容</b>
                  {v?.state == 0 && type == 1 ? (
                    <Space>
                      <Button
                        type="primary"
                        danger
                        ghost
                        onClick={() => {
                          onWithdraw && onWithdraw(v)
                        }}
                      >
                        撤回申请
                      </Button>
                      <Button
                        type="primary"
                        ghost
                        onClick={() => {
                          onChange && onChange(v)
                        }}
                      >
                        修改
                      </Button>
                    </Space>
                  ) : v?.state == 1 ? (
                    <span>审核时间：{v?.examineTime}</span>
                  ) : (
                    <></>
                  )}
                </div>
                {v?.tenantApplyDetailVOList?.map((item: any, index: number) => {
                  return type == 1 ? (
                    <div className={styles.changeItem} key={index}>
                      <span>{getKey(item?.chargeFields)}：</span>
                      {hasValue(item?.beforeCharge) && v?.askType == 1 ? (
                        <>
                          <span>
                            {item?.chargeFields == "operateStatus"
                              ? getOperateStatusName(item?.beforeCharge)
                              : item?.chargeFields == "institutionalLevel"
                              ? getInstitutionalLevelName(item?.beforeCharge)
                              : item?.chargeFields == "operateType"
                              ? getOperateTypeName(item?.beforeCharge)
                              : item?.chargeFields == "ownershipType"
                              ? getOwnershipTypeName(item?.beforeCharge)
                              : item?.chargeFields == "antibacterialState"
                              ? getAntibacterialStateName(item?.beforeCharge)
                              : item?.chargeFields == "service"
                              ? getServiceName(Number(item?.beforeCharge))
                              : item?.chargeFields == "unitCategory"
                              ? getChildItem(item?.beforeCharge)
                              : item?.beforeCharge}
                            &nbsp;
                          </span>
                          <img src={RightIcon} alt="" style={{ width: 20 }} />
                        </>
                      ) : (
                        <></>
                      )}
                      <span>
                        &nbsp;
                        {item?.chargeFields == "operateStatus"
                          ? getOperateStatusName(item?.afterCharge)
                          : item?.chargeFields == "institutionalLevel"
                          ? getInstitutionalLevelName(item?.afterCharge)
                          : item?.chargeFields == "operateType"
                          ? getOperateTypeName(item?.afterCharge)
                          : item?.chargeFields == "ownershipType"
                          ? getOwnershipTypeName(item?.afterCharge)
                          : item?.chargeFields == "antibacterialState"
                          ? getAntibacterialStateName(item?.afterCharge)
                          : item?.chargeFields == "service"
                          ? getServiceName(Number(item?.afterCharge))
                          : item?.chargeFields == "unitCategory"
                          ? getChildItem(item?.afterCharge)
                          : item?.afterCharge}
                      </span>
                      {v?.state == 1 &&
                        (item?.chargeState == 1 ? (
                          <span style={{ color: "#07C160", paddingLeft: 20 }}>
                            通过并已更新
                          </span>
                        ) : (
                          <span style={{ color: "#FF1B1B", paddingLeft: 20 }}>
                            拒绝
                          </span>
                        ))}
                    </div>
                  ) : (
                    <div className={styles.changeItem} key={index}>
                      <span>{getDoctorKey(item?.chargeFields)}：</span>
                      {hasValue(item?.beforeCharge) && v?.askType == 3 ? (
                        <>
                          <span>
                            {item?.chargeFields == "physicianType"
                              ? getOperateName(item?.beforeCharge)
                              : item?.chargeFields == "type"
                              ? "医生"
                              : item?.chargeFields == "sex"
                              ? getSexName(item?.beforeCharge)
                              : item?.chargeFields == "education"
                              ? getEducationName(Number(item?.beforeCharge))
                              : item?.chargeFields == "practiceLevel"
                              ? getPracticeLevelName(item?.beforeCharge)
                              : item?.chargeFields == "practiceCategory"
                              ? getPracticeCategoryName(item?.beforeCharge)
                              : item?.chargeFields == "appoint"
                              ? getAppointName(item?.beforeCharge)
                              : item?.chargeFields ==
                                "antibacterialDrugPermission"
                              ? getAntibacterialName(item?.beforeCharge)
                              : item?.chargeFields == "anestheticDrugPermission"
                              ? getAnestheticDrugName(item?.beforeCharge)
                              : item?.chargeFields == "workState"
                              ? getDoctorName(item?.beforeCharge)  
                              : item?.beforeCharge}
                            &nbsp;
                          </span>
                          <img src={RightIcon} alt="" style={{ width: 20 }} />
                        </>
                      ) : (
                        <></>
                      )}
                      <span>
                        &nbsp;
                        {item?.chargeFields == "physicianType"
                          ? getOperateName(item?.afterCharge)
                          : item?.chargeFields == "type"
                          ? "医生"
                          : item?.chargeFields == "sex"
                          ? getSexName(item?.afterCharge)
                          : item?.chargeFields == "education"
                          ? getEducationName(Number(item?.afterCharge))
                          : item?.chargeFields == "practiceLevel"
                          ? getPracticeLevelName(item?.afterCharge)
                          : item?.chargeFields == "practiceCategory"
                          ? getPracticeCategoryName(item?.afterCharge)
                          : item?.chargeFields == "appoint"
                          ? getAppointName(item?.afterCharge)
                          : item?.chargeFields == "antibacterialDrugPermission"
                          ? getAntibacterialName(item?.afterCharge)
                          : item?.chargeFields == "anestheticDrugPermission"
                          ? getAnestheticDrugName(item?.afterCharge)
                          : item?.chargeFields == "workState"
                          ? getDoctorName(item?.afterCharge)
                          : item?.afterCharge}
                      </span>
                      {v?.state == 1 &&
                        (item?.chargeState == 1 ? (
                          <span style={{ color: "#07C160", paddingLeft: 20 }}>
                            通过并已更新
                          </span>
                        ) : (
                          <span style={{ color: "#FF1B1B", paddingLeft: 20 }}>
                            拒绝
                          </span>
                        ))}
                    </div>
                  )
                })}
              </div>
            </div>
          )
        })}
      </Col>
    </Modal>
  )
}
